import React, {Component} from 'react';
import {FaHeart, FaBookOpen, FaVideo, FaMapMarkerAlt, FaClock, FaArrowRight, FaYoutube, FaUsers, FaPrayingHands} from 'react-icons/fa';
import {GiChurch} from 'react-icons/gi';

class Home extends Component {
    componentDidMount() {
        document.title = "EECF|基督教法国华人教会|首页"
    }

    render() {
        return (
            <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-100">
                {/* Hero Section */}
                <section className="relative overflow-hidden">
                    <div className="absolute inset-0 bg-gradient-to-br from-blue-100/30 to-blue-200/30"></div>
                    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
                        <div className="text-center">
                            <div className="inline-flex items-center justify-center w-24 h-24 bg-gradient-to-br from-blue-500 to-blue-600 rounded-3xl shadow-2xl mb-8 transform hover:scale-105 transition-transform duration-300">
                                <GiChurch className="w-12 h-12 text-white" />
                            </div>
                            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
                                欢迎来到<br/> <span className="bg-gradient-to-r from-blue-600 to-blue-700 bg-clip-text text-transparent">基督教法国华人教会</span>
                            </h1>
                            <p className="text-xl md:text-2xl text-gray-700 mb-8 max-w-3xl mx-auto leading-relaxed">
                                在信仰中建造家庭，在爱中彼此扶持
                            </p>
                            <div className="flex items-center justify-center space-x-3 text-xl text-gray-700">
                                <span className="font-medium">耶稣爱你</span>
                                <FaHeart className="text-red-500 animate-pulse" />
                            </div>
                        </div>
                    </div>
                </section>

                {/* Features Section */}
                <section className="py-20">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                            {/* About Us Card */}
                            <div className="card p-8 text-center group hover:-translate-y-2">
                                <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                                    <FaBookOpen className="w-8 h-8 text-white" />
                                </div>
                                <h3 className="text-2xl font-semibold text-gray-900 mb-4">关于我们</h3>
                                <p className="text-gray-600 leading-relaxed mb-6">
                                    法国华人教会2025年的主题目标「建造家庭」
                                </p>
                            </div>

                            {/* Physical Worship Card */}
                            <div className="card p-8 text-center group hover:-translate-y-2">
                                <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-green-600 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                                    <GiChurch className="w-8 h-8 text-white" />
                                </div>
                                <h3 className="text-2xl font-semibold text-gray-900 mb-4">实体崇拜</h3>
                                <div className="space-y-4 text-left">
                                    <div className="flex items-start space-x-3">
                                        <FaMapMarkerAlt className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
                                        <div>
                                            <p className="text-sm font-semibold text-gray-900">地址</p>
                                            <p className="text-sm text-gray-600">97 Rue Julien Lacroix 75020 Paris, France</p>
                                        </div>
                                    </div>
                                    <div className="flex items-start space-x-3">
                                        <FaClock className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
                                        <div>
                                            <p className="text-sm font-semibold text-gray-900">时间</p>
                                            <p className="text-sm text-gray-600">礼拜日 15:30-17:00</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Online Worship Card */}
                            <div className="card p-8 text-center group hover:-translate-y-2">
                                <div className="w-16 h-16 bg-gradient-to-br from-red-500 to-red-600 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                                    <FaVideo className="w-8 h-8 text-white" />
                                </div>
                                <h3 className="text-2xl font-semibold text-gray-900 mb-4">在线崇拜</h3>
                                <p className="text-gray-600 leading-relaxed mb-6">
                                    每周日我们都会进行主日崇拜，无论身在何处，都可以在线参与敬拜，与我们一起在信仰中成长。
                                </p>
                                <a href="/live" className="btn-primary hover:text-white">
                                    <span>观看直播</span>
                                    <FaArrowRight className="w-4 h-4 ml-2" />
                                </a>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
        );
    }
}

export default Home;